import { render, staticRenderFns } from "./PublishTop10.vue?vue&type=template&id=1a2cfa3b&scoped=true"
import script from "./PublishTop10.vue?vue&type=script&lang=js"
export * from "./PublishTop10.vue?vue&type=script&lang=js"
import style0 from "./PublishTop10.vue?vue&type=style&index=0&id=1a2cfa3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2cfa3b",
  null
  
)

export default component.exports